import React from 'react';

import {withCssModule} from '@pb/kit-util-with-css-module';

import styles from '../tabs.component.module.styl';

import type {ComponentProps} from 'react';


const classNames = withCssModule(styles);

export const TabImage = ({alt = '', className = '', ...props}: ComponentProps<'img'>) => {
    return (
        <img{...props} className={classNames('tabs__image', className)} alt={alt}/>
    );
};

TabImage.displayName = 'TabImage';
